import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { motion } from "framer-motion";
import "./styles/morse-login.css";
import beep from "./audio/beep.wav";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showTranslation, setShowTranslation] = useState(false);
  const navigate = useNavigate(); // Hook per navigare tra le pagine

  const playBeep = () => {
    const audio = new Audio(beep);
    audio.volume = 0.3
    audio.play();
  };

  const handleLogin = () => {
    playBeep();
    signInWithEmailAndPassword(auth, email, password)
      .then(() => {
        setError("");
        setTimeout(() => {
          navigate("/protected");
        }, 1000); // Aspetta un attimo per la dissolvenza
      })
      .catch(() => setError("... -... .- --. .-.. .. .- - ---"));
  };

  // Controlla se l'utente è già autenticato e reindirizzalo automaticamente
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        navigate("/protected"); // Se l'utente è autenticato, reindirizza
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  return (
    <div className="login-container">
      <div className="morse-background"></div>

      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="login-box"
      >
        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="morse-text"
          onMouseEnter={() => setShowTranslation(true)}
          onMouseLeave={() => setShowTranslation(false)}
        >
          {!showTranslation ? "-.-. .. .- --- 😁" : "Ciao 😁"}
        </motion.h2>

        <input
          type="text"
          className="login-input"
          placeholder=". -- .- .-.."
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            playBeep();
          }}
        />
        <div className="password-container">
          <input
            type="password"
            className="login-input morse-password"
            placeholder=".--. .- ... ... .-- --- .-. -.."
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              playBeep();
            }}
          />
        </div>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={handleLogin}
          className="login-button"
        >
          .- -.-. -.-. . -.. ..
        </motion.button>

        {error && <p className="error-message">{error}</p>}
      </motion.div>
    </div>
  );
}